// ─────────────────────────────────────────────
// This file is the entry point of the React application. 
// It conditionally loads either the lightweight LoginApp bundle for public/login
// routes or the full App bundle for authenticated routes. 
// ─────────────────────────────────────────────
import React from "react";
import ReactDOM from "react-dom";

// NON auth routes that should load the LoginApp bundle
const LOGIN_ROUTES = [
  "/login",
  "/service-center/login",
  "/fleet-reservation/auth",
  "/office-use/login",
  "/share/",
  "/share-route/",
  "/tracking/task",
  "/ratings-review/",
  "/2fa-approval/",
  "/task_email/review",
  "/maintenance",
  "/subscription-expired",
  "/site-broken",
];

const path = window.location.pathname;

const isLoginRoute =
  path === "/" ||
  LOGIN_ROUTES.some((route) => path.startsWith(route));

if (isLoginRoute) {
  // load LoginApp bundle for public/login routes
  import("./LoginApp").then(({ default: LoginApp }) => {
    ReactDOM.render(
      <React.StrictMode>
        <LoginApp />
      </React.StrictMode>,
      document.getElementById("root")
    );
  });
} else {
  // Load the full App bundle for authenticated routes
  import("./App").then(({ default: App }) => {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById("root")
    );
  });
}